import { ERROR_CODES } from "@procuremate/shared";
import type { TFunction } from "i18next";
import { ApiRequestError } from "@/lib/api-client";

/** Maps API errors from auth endpoints to user-facing text. */
export function authErrorMessage(error: unknown, t: TFunction): string | undefined {
  if (!error) return undefined;
  if (error instanceof ApiRequestError) {
    switch (error.code) {
      case ERROR_CODES.INVALID_CREDENTIALS:
        return t("auth.invalidCredentials");
      case ERROR_CODES.RATE_LIMITED:
        return t("auth.rateLimited");
      case ERROR_CODES.INVALID_TOKEN:
        return t("auth.invalidLink");
      case ERROR_CODES.VALIDATION_FAILED:
        return t("auth.checkFields");
    }
  }
  return t("auth.genericError");
}
